const crypto = require("crypto");

export function generateAvatar(email: string, size = 80) {
  if (!email) {
    return ''
  }
  const trimmedEmail = email?.trim()?.toLowerCase();
  const hash = crypto.createHash("sha256").update(trimmedEmail).digest("hex");
  return `https://www.gravatar.com/avatar/${hash}?s=${size}&d=identicon`;
}
